export const TOOLTIP_TITLE_TICKET_WATCHERS_SERVICE =
  'User prefers no Service Ticket notifications.';
export const TOOLTIP_TITLE_TICKET_WATCHERS_THREAT =
  'User prefers no Threat Ticket notifications.';
export const WARNING_MESSAGE_TICKET_WATCHERS_SERVICE =
  'Some selected watchers prefer not to receive Service Ticket notifications. This will not prevent selections from receiving notifications.';
export const WARNING_MESSAGE_TICKET_WATCHERS_THREAT =
  'Some selected watchers prefer not to receive Threat Ticket notifications or Threat Ticket notifications of a specific ticket priority. This will not prevent selections from receiving notifications.';
